import React, { useContext, useEffect, useState } from 'react';
import {  Navigate, useNavigate,  } from 'react-router-dom';
import { AuthContext } from '../AuthContext/AuthContext';
import { UserService } from '../../APIs'; 

interface ProtectedRouteProps {
  element: React.ReactNode;
  allowedRoles: string[];
  path: string;
  rest?: any;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, allowedRoles, path, rest }) => {
  const { user } = useContext(AuthContext);
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  const navigate = useNavigate();


  useEffect(() => {
    const checkAuthorization = async () => {
      if (user && user.email) {
        try {
          const response = await UserService.getUserByEmail(user.email);
          const userDetails = response.data;
          if (userDetails && allowedRoles.includes(userDetails.role)) {
            setIsAuthorized(true);
          } else {
            setIsAuthorized(false);
          }
        } catch (error) {
          console.error('Error fetching user details:', error);
          setIsAuthorized(false);
        }
      } else {
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, [user, allowedRoles]);

  useEffect(() => {
    if (isAuthorized === false) {
      navigate('/');
    }
  }, [isAuthorized, navigate]);

  if (isAuthorized === null) {
    return null; // Optionally, return a loading spinner or placeholder
  }

  return isAuthorized ? <>{element}</> : <Navigate to="/" />;
};

export default ProtectedRoute;
